import React from "react";
import { prog1 } from "../../../assets";
import { numberFormat } from "../../../helpers/numberFormat";

const DetailBundlingProgramComp = (props) => {
  return (
    <>
      <div style={{ margin: "auto", textAlign: "center", marginBottom: "3%" }}>
        <img src={prog1} alt="prog1" width="55%" />
      </div>
      <div style={{ margin: "auto", marginBottom: "3%" }}>
        <h3 className="mb-1">Nama Program :</h3>
        <ul className="mb-3" style={{ fontSize: "14px", fontWeight: "400" }}>
          {<li>{props.bundlingProgram.name} </li>}
        </ul>
        <h3 className="mb-1">Item Program :</h3>
        <ul className="mb-3" style={{ fontSize: "14px", fontWeight: "400" }}>
          {props.bundlingProgram.BundlingProgramItems.map((bpi, j) => (
            <li>{bpi?.Program?.name} </li>
          ))}
        </ul>
        <h3 className="mb-1">Harga Program :</h3>
        <ul className="mb-3">
          <li>
            <p
              style={{ fontSize: "14px", color: "#0C86D9", fontWeight: "600" }}
            >
              Rp. {numberFormat(props.bundlingProgram.price)}
            </p>
            <p style={{ fontStyle: "italic", fontSize: "12px" }}>
              * dikenakan PPN 12%
            </p>
          </li>
        </ul>
      </div>
    </>
  );
};

export default DetailBundlingProgramComp;
